<template>
  <div class="custom-fields-residential-template-card">
    <div
      class="custom-fields-residential-template-card__image"
      :style="{ backgroundImage: `url(${thumbnail})` }"
    ></div>
    <div class="custom-fields-residential-template-card__content">{{ value.name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  computed: {
    thumbnail() {
      if (!this.value) return
      let match = (this.$path('value.media.cover') || []).find(i => i.type.startsWith('image'))
      if (!match) return

      return match.url
    },
  },
}
</script>

<style lang="scss">
@import '../../styles/_mixins';
.custom-fields-residential-template-card {
  display: flex;
  align-items: center;

  &__image {
    $size: 50px;

    width: $size;
    height: $size;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    background-color: css-lighten('border-color', 2%);
    margin-right: 1rem;

    background-size: cover;
    background-position: center;
  }
}
</style>
